import React from 'react'
import { View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Button, ScreenAuth, Text, TextInput } from '@components'
import { ScreenAuthProps } from '@navigation'
import { useLanguage } from '@context'
import { useForgotPassword } from './hook'
import getStyle from './style'
import { useScreen } from '@hooks'
import { getCommonStyles } from '@utils'

export const ForgotPassword: React.FC<ScreenAuthProps<'ForgotPassword'>> = ({ navigation }) => {
  const { t } = useLanguage()

  const theme = useTheme()
  const {isMobile} = useScreen()
  const styles = getStyle(theme)
  const commonStyles = getCommonStyles(theme)


  const {
    email,
    setEmail,
    handleForgotPassword,
    isPending,
    error,
  } = useForgotPassword()

  const onBackButtonPress = () => {
    if(navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.reset({ index: 0, routes: [{ name: 'Login' }] })
    }
  }

  return (
    <ScreenAuth
      title={t('forgotPassword.title')}
      onPressBackIcon={onBackButtonPress}
      isPending={isPending}
    >
      <View style={[styles.container, !isMobile && commonStyles.flexMaxAuth]}>
        <TextInput
          placeholder={t('forgotPassword.email')}
          value={email}
          onChangeText={setEmail}
          containerStyle={styles.emailInput}
          autoCapitalize={'none'}
          iconRight='message'
        />
        {error ? (
          <Text type="bodyExtraSmall" color={theme.colors.error} style={styles.errorText}>
            {error}
          </Text>
        ) : null}

        <View style={styles.buttonContainer}>
          <Button
            title={t('forgotPassword.button')}
            onPress={handleForgotPassword}
            disabled={isPending}
          />
        </View>
      </View>
    </ScreenAuth>
  )
}
